import { render, staticRenderFns } from "./RequirementsLabel.vue?vue&type=template&id=5b926a84&scoped=true&"
import script from "./RequirementsLabel.vue?vue&type=script&lang=js&"
export * from "./RequirementsLabel.vue?vue&type=script&lang=js&"
import style0 from "./RequirementsLabel.vue?vue&type=style&index=0&id=5b926a84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b926a84",
  null
  
)

export default component.exports